import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'

export const ButtonWithIcon = styled.button<{ $isDisabled?: boolean }>`
  width: 100%;
  height: 44px;
  display: flex;
  align-items: center;
  background-color: ${COLORS.white};
  gap: 10px;
  padding: 12px 10px;
  border-radius: 4px;
  border: 1px solid ${COLORS.borderColor};
  box-sizing: border-box;
  transition: all 0.3s ease;
  cursor: pointer;

  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}

  & > span {
    font-size: 12px;
    font-weight: 500;
    color: ${COLORS.secondarySemiDark};
  }

  & > svg {
    fill: ${COLORS.secondarySemiDark};
  }

  &:hover {
    & > span {
      color: ${COLORS.secondaryDark};
    }

    & > svg {
      fill: ${COLORS.secondaryDark};
    }

    & > svg path {
      fill: ${COLORS.secondaryDark};
    }

    background-color: ${COLORS.primaryLight};
  }
`
